import api from './client';

export const dropdownService = {
    getAllAccordingToParagraph: async () => {
        const response = await api.get('according-to-paragraph');
        return response.data;
    },
    getAllMeasurements: async () => {
        const response = await api.get('measurements');
        return response.data;
    },
};